import {
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Typography,
} from "@mui/material";
import { MenuProps, options } from "./utils";
import React, { useState } from "react";

const AddCv = () => {
  const [selected, setSelected] = useState([]);
  const isAllSelected = options.length > 0 && selected.length === options.length;

  const handleChange = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setSelected(selected.length === options.length ? [] : options);
      return;
    }
    setSelected(value);
  };

  return (
    <div className="container">
      <Paper
        elevation={3}
        sx={{
          margin: "20px",
          padding: "40px",
          minHeight: "50vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Grid item xs={12}>
            <Typography
              component="div"
              color="primary"
              sx={{ textAlign: "center", fontSize: "20px" }}
            >
              Create consultant CV for a role
            </Typography>
            <Typography
              component="div"
              sx={{ textAlign: "center", fontSize: "10px" }}
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent
              venenatis, nunc in mattis blandit, justo nunc dapibus purus,
              condimentum semper risus ipsum nec arcu. Curabitur ac commodo sem.
              Nullam tempus metus et nibh iaculis porttitor. Duis sed metus
              consectetur, congue lorem ac, tincidunt neque. Etiam mollis
              viverra ipsum in accumsan.
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ padding: "10px", alignItems: "center" }}>
            <FormControl sx={{ m: 1, width: 300 }}>
              <InputLabel id="mutiple-select-label">Select Role</InputLabel>
              <Select
                labelId="mutiple-select-label"
                multiple
                value={selected}
                onChange={handleChange}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
              >
                <MenuItem
                  value="all"
                  sx={{
                    backgroundColor: isAllSelected ? "rgba(0, 0, 0, 0.08)" : "inherit",
                  }}
                >
                  <ListItemIcon>
                    <Checkbox
                      sx={{
                        color: "primary.main",
                        '&.Mui-checked': {
                          color: "primary.main",
                        },
                      }}
                      checked={isAllSelected}
                      indeterminate={
                        selected.length > 0 && selected.length < options.length
                      }
                    />
                  </ListItemIcon>
                  <ListItemText
                    sx={{
                      color: "primary.main",
                    }}
                    primary="Select All"
                  />
                </MenuItem>
                {options.map((option) => (
                  <MenuItem key={option} value={option}>
                    <ListItemIcon>
                      <Checkbox checked={selected.indexOf(option) > -1} />
                    </ListItemIcon>
                    <ListItemText primary={option} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sx={{ padding: "10px", alignItems: "center" }}>
            <FormControl sx={{ m: 1, width: 300 }}>
              <InputLabel id="mutiple-select-label-2">
                Select Primary Role
              </InputLabel>
              <Select
                labelId="mutiple-select-label-2"
                multiple
                value={selected}
                onChange={handleChange}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
              >
                <MenuItem
                  value="all"
                  sx={{
                    backgroundColor: isAllSelected ? "rgba(0, 0, 0, 0.08)" : "inherit",
                  }}
                >
                  <ListItemIcon>
                    <Checkbox
                      sx={{
                        color: "primary.main",
                        '&.Mui-checked': {
                          color: "primary.main",
                        },
                      }}
                      checked={isAllSelected}
                      indeterminate={
                        selected.length > 0 && selected.length < options.length
                      }
                    />
                  </ListItemIcon>
                  <ListItemText
                    sx={{
                      color: "primary.main",
                    }}
                    primary="Select All"
                  />
                </MenuItem>
                {options.map((option) => (
                  <MenuItem key={option} value={option}>
                    <ListItemIcon>
                      <Checkbox checked={selected.indexOf(option) > -1} />
                    </ListItemIcon>
                    <ListItemText primary={option} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

export default AddCv;